const MuiAccordionSummary = {
  styleOverrides: {
    root: {
      '&.Mui-expanded': {
        margin: 'initial',
        minHeight: 56,
      },
      minHeight: 56,
      padding: '0 24px',
    },
  },
};

export default MuiAccordionSummary;
